import { FC, useState } from 'react';
import {
  DragNDropRecExpanded,
  RecExpandedRowBase,
} from 'components/DragNDrop/DragNDropRecExpanded';
import { GroupSectionProps } from '../types';
import { GROUP_LABEL_MAX_LENGTH } from '../DonationAllocationForm/constants';

export const GroupSection: FC<GroupSectionProps> = ({
  group,
  groupIndex,
  groupCount,
  recipients,
  inputControl,
  onMoveRecipient,
  onReorder,
  onRemove,
  onGroupChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const rows: RecExpandedRowBase[] = group.recipient_ids.map(id => {
    const rec = recipients.find(r => r.recipient_id === id);
    return { value: id, label: rec?.recipient_name || id };
  });

  const otherGroupIndices = Array.from({ length: groupCount }, (_, i) => i).filter(
    i => i !== groupIndex
  );

  const renderRowExtra =
    groupCount > 1
      ? (value: string) => (
          <select
            className="move-group-select oath-utility"
            value=""
            onChange={e => {
              const toIndex = parseInt(e.target.value, 10);
              if (!isNaN(toIndex)) onMoveRecipient(value, toIndex);
            }}
          >
            <option value="" disabled>
              Move to…
            </option>
            {otherGroupIndices.map(i => (
              <option key={i} value={i}>
                Group {i + 1}
              </option>
            ))}
          </select>
        )
      : undefined;

  return (
    <div className="section-container allocation-group">
      <div className="row align-center justify-between">
        <div className="allocation-group-left">
          <div className="allocation-group-badge oath-bodysmall">{groupIndex + 1}</div>
          <span className="oath-bodysmall inkBlue">
            {group.group_label || `Group ${groupIndex + 1}`}
          </span>
        </div>
        <div className="collapse-container">
          <span className="oath-utility gray">
            {group.group_label
              ? `${group.group_label} Allocation`
              : `Group ${groupIndex + 1} Allocation`}
          </span>
          {inputControl}
          <button
            type="button"
            className="oath-bodysmall link-text gray padding0"
            onClick={() => setIsExpanded(prev => !prev)}
          >
            {isExpanded ? 'Close details' : 'Edit details'}
          </button>
        </div>
      </div>

      {isExpanded && (
        <>
          <div className="allocation-group-label">
            <label className="oath-utility gray" htmlFor={`group-label-${groupIndex}`}>
              Group Label (optional)
            </label>
            <input
              id={`group-label-${groupIndex}`}
              type="text"
              className="form-control"
              placeholder={`Group ${groupIndex + 1}`}
              value={group.group_label || ''}
              maxLength={GROUP_LABEL_MAX_LENGTH}
              onChange={e => onGroupChange({ group_label: e.target.value || null })}
            />
          </div>
          {rows.length > 0 ? (
            <DragNDropRecExpanded
              rows={rows}
              setRows={newRows => onReorder(newRows.map(r => r.value))}
              withDetails={false}
              impactScoreVisibility={false}
              disableDelete={true}
              forceActive={true}
              renderRowExtra={renderRowExtra}
            />
          ) : (
            <p className="oath-utility gray allocation-group-empty">No recipients in this group</p>
          )}
          {groupIndex >= 2 && (
            <button
              type="button"
              className="oath-bodysmall link-text gray padding0"
              onClick={onRemove}
            >
              Remove Group
            </button>
          )}
        </>
      )}
    </div>
  );
};
